import {Navigate, useLocation} from "react-router-dom";

import {Login} from "@/pages/auth/login.tsx";

import {useAuth} from "@/lib/auth";

export const LoginRoute = () => {
  const {token, scope, loading} = useAuth();
  const loc = useLocation();

  if (loading) return null;
  if (token) {
    const to =
      new URLSearchParams(loc.search).get("to") ||
      (scope === "account" ? "/admin" : "/servers");
    return <Navigate to={to} replace />;
  }

  return <Login />;
};
